(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-hero"] && !Shopify.designMode) return;
  try {
    (()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const init=()=>{const nodes=document.querySelectorAll('.aa>*,.ac>*,.ap>*,.aj>*,.ads>header,.ads-chapter,.ak>*,.acl>*,.tcatch>header,.tcatch__track');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('atelier-motion-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -7%'});nodes.forEach(node=>{if(node.dataset.atelierMotion)return;node.dataset.atelierMotion='true';node.classList.add('atelier-motion-item');observer.observe(node)})};init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-todays-catch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.tcatch');
    if (!root) return;
    const track = root.querySelector('[data-tcatch-track]');
    if (!track) return;
    const cards = track.children;
    if (cards.length < 2) return;

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const step = () => cards[0].getBoundingClientRect().width + 20;

    const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    root.querySelectorAll('[data-tcatch-next]').forEach((b) => b.addEventListener('click', () => go(1)));
    root.querySelectorAll('[data-tcatch-prev]').forEach((b) => b.addEventListener('click', () => go(-1)));

    if (root.dataset.autoplay !== 'true' || reduce) return;

    let timer = null;
    const tick = () => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
      else go(1);
    };
    const start = () => { if (!timer) timer = setInterval(tick, 3800); };
    const stop = () => { clearInterval(timer); timer = null; };

    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
